import {ResourceAllocationState, Person} from '../../../types';
import {removePersonCascade} from '../cascadeDelete';

export const personHandlers = {
    PersonAdded: (
        state: ResourceAllocationState,
        data: Person
    ): ResourceAllocationState => {
        return {
            ...state,
            people: {
                ...state.people,
                [data.id]: {
                    ...data,
                    teamIds: data.teamIds || [],
                    roleIds: data.roleIds || [],
                    customerRoles: data.customerRoles || []
                }
            }
        };
    },
    PersonUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<Person>}
    ): ResourceAllocationState => {
        // A scoped /state doesn't hold the whole tenant — an update about an
        // unloaded person is irrelevant here, and spreading undefined would
        // fabricate a ghost entity.
        if (!state.people[data.id]) {
            return state;
        }
        return {
            ...state,
            people: {
                ...state.people,
                [data.id]: {
                    ...state.people[data.id],
                    ...data.updates
                }
            }
        };
    },
    PersonDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        // Mirror the DB cascade: also prune this person's project-people and
        // personal availability / availability weeks.
        return removePersonCascade(state, data.id);
    }
};
